import { http } from "@/lib/http";
import { isMockEnabled } from "@/lib/mock-flags";
import * as mock from "../mocks/fixtures";
import type { DashboardSummary } from "../mocks/fixtures";

export const getDashboardSummary = async (): Promise<DashboardSummary> => {
  if (isMockEnabled("agency")) {
    return mock.getDashboardSummary();
  }
  const { data } = await http.get<DashboardSummary>("/dashboard/summary", {
    params: { period: "last_30_days" },
  });
  return data;
};

export type { DashboardSummary } from "../mocks/fixtures";
